import React from 'react';

import type { RouteObject } from 'react-router-dom';

import { Pages } from '@/pages';

const Information = React.lazy(() => import('./views/Information'));
const Contracts = React.lazy(() => import('./views/Contracts'));
const PlannedVolume = React.lazy(() => import('./views/PlannedVolume'));

export const meteringPointDetailsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Information />,
  },
  {
    path: Pages.CONTRACTS,
    element: <Contracts />,
  },
  {
    path: Pages.CONTRACT_PLANNED_VOLUME_PART,
    element: <PlannedVolume />,
  },
];
